import { PageContent } from '../components/PageContent';
import { PageWithTitle } from '../components/PageWithoutTitle';
import { useNextAppConfig } from '../hooks/useNextAppConfig';

export default function About() {
  const config = useNextAppConfig();

  return (
    <PageContent>
      <PageWithTitle title="" />
      <p>O aplikacji</p>
      <p>Aktualna wersja aplikacji to {config?.version}</p>
    </PageContent>
  );
}
